import { colors } from '@kbbcomponentlibrary/principles'
import { fonts } from '@kbbcomponentlibrary/principles'
import { common } from '@kbbcomponentlibrary/principles/dist/colors'

// colors

//common
export const black = common.black
export const white = common.white

//blue
export const blueBase = colors.blue.base
export const blueDark40 = colors.blue.dark40
export const blueDark30 = colors.blue.dark30
export const blueDark20 = colors.blue.dark20
export const blueDark10 = colors.blue.dark10
export const blueLight10 = colors.blue.light10
export const blueLight20 = colors.blue.light20
export const blueLight30 = colors.blue.light30
export const blueLight40 = colors.blue.light40
export const blueLight45 = colors.blue.light45

//cyan
export const cyanBase = colors.cyan.base
export const cyanDark40 = colors.cyan.dark40
export const cyanDark30 = colors.cyan.dark30
export const cyanDark20 = colors.cyan.dark20
export const cyanDark10 = colors.cyan.dark10
export const cyanLight10 = colors.cyan.light10
export const cyanLight20 = colors.cyan.light20
export const cyanLight30 = colors.cyan.light30
export const cyanLight40 = colors.cyan.light40
export const cyanLight45 = colors.cyan.light45

//gold
export const goldBase = colors.gold.base
export const goldDark40 = colors.gold.dark40
export const goldDark30 = colors.gold.dark30
export const goldDark20 = colors.gold.dark20
export const goldDark10 = colors.gold.dark10
export const goldLight10 = colors.gold.light10
export const goldLight20 = colors.gold.light20
export const goldLight30 = colors.gold.light30
export const goldLight40 = colors.gold.light40
export const goldLight45 = colors.gold.light45

//gray
export const grayBase = colors.gray.base
export const grayDark = '#737373'
export const grayDark40 = colors.gray.dark40
export const grayDark30 = colors.gray.dark30
export const grayDark20 = colors.gray.dark20
export const grayDark10 = colors.gray.dark10
export const grayLight10 = colors.gray.light10
export const grayLightB5 = '#808080'
export const grayLight20 = colors.gray.light20
export const grayLight30 = colors.gray.light30
export const grayLight40 = colors.gray.light40
export const grayLight45 = colors.gray.light45

//green
export const greenBase = colors.green.base
export const greenDark40 = colors.green.dark40
export const greenDark30 = colors.green.dark30
export const greenDark20 = colors.green.dark20
export const greenDark10 = colors.green.dark10
export const greenLight10 = colors.green.light10
export const greenLight20 = colors.green.light20
export const greenLight30 = colors.green.light30
export const greenLight40 = colors.green.light40
export const greenLight45 = colors.green.light45
export const greenLight = '#379302'

//highlightblue
export const highlightBlueBase = colors.highlightblue.base
export const highlightBlueDark40 = colors.highlightblue.dark40
export const highlightBlueDark30 = colors.highlightblue.dark30
export const highlightBlueDark20 = colors.highlightblue.dark20
export const highlightBlueDark10 = colors.highlightblue.dark10
export const highlightBlueLight10 = colors.highlightblue.light10
export const highlightBlueLight20 = colors.highlightblue.light20
export const highlightBlueLight30 = colors.highlightblue.light30
export const highlightBlueLight40 = colors.highlightblue.light40
export const highlightBlueLight45 = colors.highlightblue.light45

//red
export const redBase = colors.red.base
export const redDark40 = colors.red.dark40
export const redDark30 = colors.red.dark30
export const redDark20 = colors.red.dark20
export const redDark10 = colors.red.dark10
export const redLight10 = colors.red.light10
export const redLight20 = colors.red.light20
export const redLight30 = colors.red.light30
export const redLight40 = colors.red.light40
export const redLight45 = colors.red.light45

//Argo

//Primary
export const airForceBlue = '#2b5195'
export const riverBlue = '#5586d4'
export const argoBlue = '#0799f8'
export const offWhite = '#f8f8f8'
export const argoGold = '#F3BC2A'
export const argoRed = '#f43a36'
export const argoDisabled = '#f2f2f2'
export const argoText = '#505050'
export const argoInputBorder = '#dcdcdc'

//fonts
export const fontFamilyOpenSans = fonts.family.opensans

export const fontSize3XLarge = fonts.size['3XLarge']
export const fontSize2XLarge = fonts.size['2XLarge']
export const fontSizeXLarge = fonts.size.XLarge
export const fontSizeLarge = fonts.size.Large
export const fontSizeMedium = fonts.size.Medium
export const fontSizeSmall = fonts.size.Small
export const fontSizeXSmall = fonts.size.XSmall
export const fontSize2XSmall = fonts.size['2XSmall']
export const fontSize3XSmall = fonts.size['3XSmall']
export const fontSize4XSmall = fonts.size['4XSmall']

export const fontWeightBold = fonts.weight.bold
export const fontWeightSemibold = fonts.weight.semibold
export const fontWeightRegular = fonts.weight.regular
export const fontWeightLight = fonts.weight.light
